"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RUNNING_IMPORT_MAX_AGE_HOURS = exports.MAGIC_IMPORT_MAX_CONVERSIONS = exports.parseMagicImportEntryPoint = exports.getMagicImportIntroQuery = exports.MAGIC_IMPORT_INTRO_STEP = exports.MagicImportProvider = exports.MagicImportEntryPoint = exports.ImportSocketEvent = exports.ImportStatus = void 0;
var ImportStatus;
(function (ImportStatus) {
    ImportStatus["Created"] = "Created";
    ImportStatus["Processing"] = "Processing";
    ImportStatus["Failed"] = "Failed";
    ImportStatus["Succeeded"] = "Succeeded";
})(ImportStatus || (exports.ImportStatus = ImportStatus = {}));
var ImportSocketEvent;
(function (ImportSocketEvent) {
    ImportSocketEvent["JoinRoom"] = "import:joinRoom";
    ImportSocketEvent["LeaveRoom"] = "import:leaveRoom";
    ImportSocketEvent["JobCompleted"] = "import:jobCompleted";
})(ImportSocketEvent || (exports.ImportSocketEvent = ImportSocketEvent = {}));
var MagicImportEntryPoint;
(function (MagicImportEntryPoint) {
    MagicImportEntryPoint["ContactsChooser"] = "contactsChooser";
    MagicImportEntryPoint["Checklist"] = "checklist";
    MagicImportEntryPoint["GalleryCard"] = "galleryCard";
    MagicImportEntryPoint["ManualImportPage"] = "manualImportPage";
    MagicImportEntryPoint["TemplatesPage"] = "templatesPage";
    MagicImportEntryPoint["ManualImportPageTemplates"] = "manualImportPageTemplates";
    MagicImportEntryPoint["IntegrationsPage"] = "integrationsPage";
})(MagicImportEntryPoint || (exports.MagicImportEntryPoint = MagicImportEntryPoint = {}));
var MagicImportProvider;
(function (MagicImportProvider) {
    MagicImportProvider["Mailchimp"] = "mailchimp";
    MagicImportProvider["ConstantContact"] = "constantcontact";
})(MagicImportProvider || (exports.MagicImportProvider = MagicImportProvider = {}));
exports.MAGIC_IMPORT_INTRO_STEP = "intro";
const getMagicImportIntroQuery = (provider, entryPoint, returnUrl) => ({
    import: "true",
    importStep: exports.MAGIC_IMPORT_INTRO_STEP,
    importProvider: provider,
    ...(entryPoint ? { importEntryPoint: entryPoint } : {}),
    ...(returnUrl ? { importReturnUrl: returnUrl } : {}),
});
exports.getMagicImportIntroQuery = getMagicImportIntroQuery;
const parseMagicImportEntryPoint = (value) => Object.values(MagicImportEntryPoint).find((entryPoint) => entryPoint === value);
exports.parseMagicImportEntryPoint = parseMagicImportEntryPoint;
exports.MAGIC_IMPORT_MAX_CONVERSIONS = 20;
exports.RUNNING_IMPORT_MAX_AGE_HOURS = 24;
